<div class="mb-4">
  <h5 class="text-[20px] text-heading font-bold mb-1 leading-none">Disbursement Voucher</h5>
  <ul>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.dashboard">Home</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
      <a [routerLink]="routes.disbursementNavigator">Disbursement</a>
    </li>
    <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
      <i class="far fa-chevron-right"></i>
    </li>
    <ng-container *ngIf="controlNumber$|async as control">
      <ng-container [ngSwitch]="type$|async">
        <ng-container *ngSwitchCase="'Reimbursement'">
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
            <a [routerLink]="routes.reimbursement">Reimbursement</a>
          </li>
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
            <i class="far fa-chevron-right"></i>
          </li>
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
            <a [routerLink]="[routes.reimbursement, control]">{{control}}</a>
          </li>
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
            <i class="far fa-chevron-right"></i>
          </li>
        </ng-container>
        <ng-container *ngSwitchCase="'Cash Advance'">
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
            <a [routerLink]="routes.cashAdvance">Cash Advance</a>
          </li>
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
            <i class="far fa-chevron-right"></i>
          </li>
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
            <a [routerLink]="[routes.cashAdvance, control]">{{control}}</a>
          </li>
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
            <i class="far fa-chevron-right"></i>
          </li>
        </ng-container>
        <ng-container *ngSwitchCase="'Liquidation'">
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
            <a [routerLink]="routes.liquidation">Liquidation</a>
          </li>
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
            <i class="far fa-chevron-right"></i>
          </li>
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2">
            <a [routerLink]="[routes.liquidation, control]">{{control}}</a>
          </li>
          <li class="text-[14px] text-bodyText font-normal inline-block mr-2 translate-y-0">
            <i class="far fa-chevron-right"></i>
          </li>
        </ng-container>
      </ng-container>
    </ng-container>
    <li *ngIf="(disbursementVoucher$|async)?.Info?.VoucherNumber as voucherNumber"
      class="text-[14px] font-semibold font-normal inline-block mr-2">
      {{voucherNumber||'Voucher'}}
    </li>
  </ul>
</div>

<div *ngIf="disbursementVoucher$|async as voucher" class="bg-white p-4 mb-10">
  <div class="mb-4">
    <div class="form-submit">
      <button (click)="printVoucher()" type="button" class="custom-button custom-button-success">
        <i class="fa-light fa-print"></i> Print
      </button>
      <button (click)="downloadVoucher()" type="button" class="custom-button custom-button-success-filled">
        <i class="fa-light fa-download"></i> Download CSV
      </button>
    </div>
  </div>

  <div id="ngx-print-section">
    <div class="table-responsive p-4">
      <table class="w-[100%] h-[95vh]" id="ngx-print-table">
        <tr>
          <td colspan="4">VAT Reg</td>
          <td rowspan="2">
            <div class="flex-end">
              <div class="border p-2">{{voucher.Info.VoucherNumber}}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="text-xl font-bold" colspan="4">CASH DISBURSEMENT VOUCHER</td>
        </tr>

        <tr>
          <td class="text-xs p-1 border" colspan="3">
            <span class="font-bold mr-4">Pay to the Order of</span>
            <span>{{voucher.Info.PayToTheOrderOf}}</span>
          </td>
          <td class="text-xs p-1 border">
            <span class="font-bold mr-4">Date</span>
            <span>{{voucher.Info.DateCreated|date}}</span>
          </td>
          <td class="text-xs p-1 border">
            <span class="font-bold mr-4">Doc No</span>
            <span>{{voucher.Info.DocNo|date}}</span>
          </td>
        </tr>

        <tr>
          <td class="text-xs p-1 border" colspan="3">
            <div class="flex justify-between  mr-4">
              <span class="font-bold">Payee</span>
              <span>{{voucher.Info.Payee}}</span>
              <span class="text-end">VAT Reg</span>
            </div>
          </td>
          <td class="text-xs p-1 border">
            <span class="font-bold mr-4">Amount</span>
            <span>{{voucher.Info.Amount|currency:'₱ '}}</span>
          </td>
          <td class="text-xs p-1 border">
            <span class="font-bold mr-4">Doc Date</span>
            <span>{{voucher.Info.DateCreated|date}}</span>
          </td>
        </tr>

        <tr>
          <td class="text-xs p-1 border" colspan="5">
            <span class="font-bold mr-4">Amount in Pesos</span>
            <span>{{Helper.number.numberToWords(voucher.Info.Amount)}}</span>
            <br>
            <br>
          </td>
        </tr>

        <tr>
          <td class="text-xs p-1 border" colspan="5">
            <span class="font-bold mr-4">Particulars</span>
            <span>{{voucher.Info.Particulars}}</span>
            <br>
            <br>
            <br>
          </td>
        </tr>

        <tr>
          <td class="text-xs p-1 border font-bold">Account</td>
          <td class="text-xs p-1 border font-bold">SuAccount</td>
          <td class="text-xs p-1 border font-bold">Description</td>
          <td class="text-xs p-1 border font-bold text-end"> Debit</td>
          <td class="text-xs p-1 border font-bold text-end"> Credit</td>
        </tr>

        <tr *ngFor="let item of voucher.Items" class="border-x">
          <td class="text-xs p-1">{{item.Account}}</td>
          <td class="text-xs p-1">{{item.SubAccount}}</td>
          <td class="text-xs p-1">{{item.Description}}</td>
          <td class="text-xs p-1 text-end">{{item.Debit|toFixed:2}}</td>
          <td class="text-xs p-1 text-end">{{item.Credit|toFixed:2}}</td>
        </tr>

        <tr class="p-1 border-x h-[100%]">
          <td colspan="5"></td>
        </tr>

        <tr>
          <td class="text-xs p-1 border" colspan="2">
            <span class="mr-4">Prepared By:</span>
            <span>{{''}}</span>
          </td>
          <td class="text-xs p-1 border" colspan="3" rowspan="5">
            <div class="mb-1">
              <span class="mr-4">Received from:</span>
              <span class="border-b pl-1 pr-9">AGF Security Agency Corp.</span>
            </div>
            <div class="mb-1">
              <span class="mr-4">Check No.:</span>
              <span class="border-b pl-1 pr-9"></span>
            </div>
            <div class="mb-1">
              <span class="mr-4">Dated:</span>
              <span class="border-b pl-1 pr-9">{{Helper.date.newDate|date}}</span>
            </div>
            <div class="mb-1">
              <span class="mr-4">In the amount of</span>
              <span class="border-b pl-1 pr-9">{{voucher.Info.Amount|currency:'₱ '}}</span>
            </div>
            <div class="mb-1">
              <span class="mr-4">in full/partial settlement of the above describe account.</span>
            </div>
            <div class="mb-1">
              <div class="flex justify-around gap-x-4 mt-5">
                <span class="border-t px-9">Signature</span>
                <span class="border-t px-9">Printed Name & Date</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="text-xs p-1 border" colspan="2">
            <span class="mr-4">Date Printed:</span>
            <span>{{Helper.date.newDate|date}}</span>
          </td>
        </tr>
        <tr>
          <td class="text-xs p-1 border" colspan="2">
            <span class="mr-4">Noted By:</span>
            <span></span>
          </td>
        </tr>
        <tr>
          <td class="text-xs p-1 border" colspan="2">
            <span class="mr-4">Approved By:</span>
            <span></span>
          </td>
        </tr>
        <tr>
          <td class="text-xs p-1 border" colspan="2">
            <span>Page 1 of 1</span>
          </td>
        </tr>

      </table>
    </div>
  </div>
</div>